import { SET_DRAFT, CLEAR_DRAFT } from "@Actions/types";

export default function reducer(
	state = {
		draft: {},
	},
	action
) {
	const { type, payload } = action;
	switch (type) {
		case CLEAR_DRAFT: {
			return {
				...state,
				draft: {},
			};
		}

		case SET_DRAFT: {
			return {
				...state,
				draft: payload.data,
			};
		}

		default:
			return state;
	}
}
